import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "forum",
  "use": "forum-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"forum\"><path d=\"M15.992 1.6c0-.882-.714-1.6-1.592-1.6H1.6C.718 0 0 .718 0 1.6v9.6c0 .882.718 1.6 1.6 1.6h11.201l3.2 3.2-.009-14.4zm-2.777 10.2H1.6a.608.608 0 0 1-.6-.6V1.6c0-.325.275-.6.6-.6h12.8c.326 0 .592.269.592.601l.007 11.983-1.784-1.784zM5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./application/components/dumb/icon/src/forum.svg
// module id = 163
// module chunks = 0